<template>
    <div dir="ltr">
        <div class="text-h5" v-if="! discountedDisplayableRate">
            <q-spinner-dots size="20px" color="white" />
        </div>
        <q-item class="q-my-sm q-pa-none" clickable dark @click="displayChart = true" v-else>
            <q-item-section avatar class="q-pa-none">
                <lottie
                    :options="animationOptions"
                    :height="40"
                    :width="40"
                    class="col-1 q-ml-none"
                />
            </q-item-section>

            <q-item-section dir="ltr">
                <q-item-label class="text-h6">
                    <currency-format :value="1"
                                     hide-zero-decimal
                                     hide-white-spaces
                                     style="display:inline-block"
                                     :unit="displayable_origin_symbol"
                    />
                    =
                    <currency-format :value="undiscountedDisplayableRate"
                                     hide-zero-decimal
                                     hide-white-spaces
                                     style="display:inline-block"
                                     :unit="displayable_dest_symbol"
                    />
                </q-item-label>
                <q-item-label caption>
                    Updated {{elapsedTime}}
                </q-item-label>
            </q-item-section>

            <q-item-section side>
                <q-btn flat round color="white" @click="displayChart = true">

                    <q-icon name="fa fa-line-chart"/>
                </q-btn>
            </q-item-section>
        </q-item>

        <rate-chart-dialog
            v-model="displayChart"
            :from="from_currency"
            :to="to_currency"
            :decimals="decimals"
            :current-rate="discountedDisplayableRate"
            :rate-reversed="rateReversed"
            :elapsed-time="elapsedTime"
        />
    </div>
</template>
<script>

import Lottie from 'vue-lottie'
import animationData from 'src/assets/lottie/green-circle.json'
import RateChartDialog from "../RateChartDialog.vue";
export default {
    name: "RateMonitor",
    props: {
        rate: {
            type: Number,
            default: 0,
        },
        ramp: {
            type: Object,
            required: true
        },
        rateReversed: {
            type: Boolean,
            default: false
        },
        discountedDisplayableRate: {
            type: Number,
            default: 0
        },
        undiscountedDisplayableRate: {
            type: Number,
            default: 0
        },
        updateDateTime: {
            type: String,
            default: ''
        }
    },
    computed: {
        from_currency() {
            return this.ramp.from
        },
        to_currency() {
            return this.ramp.to
        },
        displayable_origin_symbol() {
            return this.rateReversed ? this.to_currency.symbol : this.from_currency.symbol
        },
        displayable_dest_symbol() {
            return this.rateReversed ? this.from_currency.symbol : this.to_currency.symbol
        },
        decimals() {
            return (this.ramp.decimals > 0) ? this.ramp.decimals : 0
        }
    },
    data() {
        return {
            animationOptions: {animationData: animationData},
            displayChart: false,
            elapsedTime: this.$timeAgo(this.updateDateTime)
        }
    },
    methods: {},
    created() {
    },
    mounted() {
        this.intervalId = setInterval(() => {
            this.elapsedTime = this.$timeAgo(this.updateDateTime)
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.intervalId)
    },
    watch: {
        updateDateTime(value) {
            this.elapsedTime = this.$timeAgo(value)
        }
    },
    components: {RateChartDialog, Lottie},
}
</script>
<style>

</style>
